<div class="autocomplete">
    <div class="input-icon">
        <input [(ngModel)]="input" 
               class="form-control" 
               type="text"
               [ngModelOptions]="{standalone: true}"
               (keyup)="getAllItems()"
               placeholder="{{placeholder || 'Pretraži'}}">
        <div class="input-icon-addon">
            <i class="fe fe-search"></i>
        </div>
    </div>
    <div class="form-control mt-3" *ngIf="operationInfo && !isSubmitted">
        <div><b>{{ operationInfo.client }} - {{ includeOperations === 'true' ? operationInfo.name + ' - ' + operationInfo.workOrderName : operationInfo.workOrderName }} - {{ operationInfo.workOrderUpisId }}</b></div> 
        <div class="text-end mt-1" *ngIf="includeOperations === 'true'">    
            <div class="tag me-2">
                {{ operationInfo.quantity | number: '1.0-3':'sr-Latn' }} ({{ operationInfo.quantityFinishedTotal | number: '1.0-3':'sr-Latn' }})
                <span class="tag-addon"><i class="fa fa-layer-group"></i></span>
            </div>
            <div class="tag me-2">
                <span>{{ operationInfo.timeEstimatedEmployee | number: '1.0-0':'sr-Latn' }}min</span> 
                <span *ngIf="operationInfo.workersCount > 1" class="ms-1">x{{ operationInfo.workersCount }}</span>
                <span class="tag-addon"><i class="fa fa-user"></i></span>
            </div>
            <div class="tag">
                {{ operationInfo.timeEstimatedMachine | number: '1.0-0':'sr-Latn' }}min
                <span class="tag-addon"><i class="fa fa-cog"></i></span>
            </div>
        </div>
    </div>

    <div class="autocomplete__list" *ngIf="isListVisible" [ngStyle]="{'top': isListVisible ? '37px' : '100%'} ">
        <div class="autocomplete__item" *ngFor="let item of items; trackBy: trackByFn" (click)="onSelect(item)">
          <div>{{ item.client }} - {{ includeOperations === 'true' ? item.name + ' - ' + item.workOrderName : item.workOrderName }} - {{ item.workOrderUpisId }}</div>
          <div class="text-end" *ngIf="includeOperations === 'true'">
              <div class="tag me-2">
                {{ item.quantity | number: '1.0-3':'sr-Latn' }} ({{ item.quantityFinishedTotal | number: '1.0-3':'sr-Latn' }})
                <span class="tag-addon"><i class="fa fa-layer-group"></i></span>
              </div>
              <div class="tag me-2">
                <span>{{ item.timeEstimatedEmployee | number: '1.0-0':'sr-Latn' }}min</span>
                <span *ngIf="item.workersCount > 1" class="ms-1">x{{ item.workersCount }}</span>
                <span class="tag-addon"><i class="fa fa-user"></i></span>
              </div>
              <div class="tag">
                {{ item.timeEstimatedMachine | number: '1.0-0':'sr-Latn' }}min
                <span class="tag-addon"><i class="fa fa-cog"></i></span>
              </div>
          </div>
        </div>
    </div>

</div>
